<template>
  <div>
    <div class="page-title">Edit Submission Form</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="update"
      btnText="Update Submission Form"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.submission-forms.page";
export default {
  components: { Form },
  metaInfo() {
    const subject = this.form?.title;
    return {
      title: subject
        ? `Edit “${subject}” Submission Form`
        : `Edit Submission Form`,
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.SubmissionForm.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
    async update() {
      await this.$api.SubmissionForm.update(this.form);
      this.$router.push("/widgets/submission-forms");
    },
  },
};
</script>

<style></style>
